import React from 'react'
import FooterWidgetComponent from '../../widgets/FooterWidget/FooterWidgetComponent'
import AboutBannerComponent from './widget/AboutBanner/AboutBannerComponent'
import SectionAComponent from './widget/SectionA/SectionAComponent'

function About() {
  return (
    <div>
        <AboutBannerComponent/>
        <SectionAComponent/>
        <FooterWidgetComponent/>
    </div>
  )
}

export default About